/**
 * Label of the last breadcrumb item (the current page in the trail).
 */
export const getFinalBreadcrumbLabel = (items) => {
  if (!items?.length) {
    return null
  }

  const label = items[items.length - 1]?.label?.trim()
  return label || null
}
